import './footer.css'
const footer = () => {
  return (
    <footer>
      <div className='footer_copyright'>
        <small>&copy; 2026 Haowei Lou. Last updated June 2026.</small>
      </div>
    </footer>
  )
}

export default footer
